import { createFileRoute } from '@tanstack/react-router'
import { NewOrgDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditOrgDialog from '@/routes/_app/-dialogs/edit-org'

export const Route = createFileRoute('/@modal/orgs/new')({
  staticData: { slotScope: '/_app/orgs' },
  pendingComponent: NewOrgDialogPending,
  component: NewOrgSlot,
})

function NewOrgSlot() {
  const slot = useModalSlot(Route)
  return <EditOrgDialog {...slot} />
}
